module.exports = __webpack_public_path__ + "img/5.9a091526.png";